/**
 @ngdoc service
 @name mapDistributionTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapDistributionTileService = function(tileDataFactory, $filter) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data

            if(tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('universalId', 'itemURI'));
            } else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('universalId', 'showURI'));
            }

            var label;
            var value = rawTileData.quantityFilled + '/' + rawTileData.quantity;
            var requester = requesterData.role.roleType.isProcurer ? "Procurer" : "NonProcurer";
            if(tileFactory.isPrincipal() && requester == "NonProcurer"){
                label = objectTilesLabels.quantityFilled.label;
            }else{
                label = objectTilesLabels.progress.label;
            }
            tileFactory.addFieldToColumn1({label: label, value: value});

            tileFactory.addFieldToColumn1(tileFactory.field.newLinkJoinField('itemHiringManagerFirstName','itemHiringManagerLastName','itemHiringManagerURI'));
            if(rawTileData.totalSubmissions){
                var submissionsRemaining;
                submissionsRemaining = rawTileData.totalSubmissions - rawTileData.submissionsMade;
                tileFactory.addFieldToColumn1({label: objectTilesLabels.submissionsRemaining.label, value: submissionsRemaining});
            }

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('workingAddress'));
            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName', 'procurerOrgName','businessRecordURI'));
            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newField('supplierOrgName'));
                tileFactory.addFieldToColumn2(tileFactory.field.newField('supplierOrgUnitName'));
            }
            tileFactory.addFieldToColumn2(tileFactory.field.newField('assignedToRoleName'));

            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitRangeFieldLite('payFrom','payTo','interimRateType'));

            if(!tileFactory.isPrincipal()) {
                if (rawTileData.isInterim) {
                    tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate', 'date'));
                    tileFactory.addFieldToColumn3(tileFactory.field.newField('endDate', 'date'));
                }
                tileFactory.addFieldToColumn3(tileFactory.field.newFieldBooleanYesOrNo('candidateAttributesRequired'));
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('firstSubmission'));
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('firstInterview'));
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('firstBooking'));
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('timeToClaim'));
            }else{
                tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate', 'date'));
            }

            if(tileFactory.isPrincipal()){
                if(rawTileData.cvCount > 0) {
                    tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('cvCount', 'cvCountURI'));
                }
                else{
                    tileFactory.addFieldToColumn4(tileFactory.field.newField('cvCount'));
                }

                if(rawTileData.interviewCount > 0) {
                    tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('interviewCount', 'interviewCountURI'));
                }
                else{
                    tileFactory.addFieldToColumn4(tileFactory.field.newField('interviewCount'));
                }

                tileFactory.addFieldToColumn3(tileFactory.field.newField('dateCreated', 'date'));

            }

            if(rawTileData.totalApplications > 0){
                var totalApplications = rawTileData.applicationsAwaitingReview + " / " + rawTileData.totalApplications;
                if(rawTileData.totalApplicationsURI){
                    tileFactory.addFieldToColumn3({label:objectTilesLabels.jobApplicants.label, value:totalApplications, link: rawTileData.totalApplicationsURI});
                }else{
                    tileFactory.addFieldToColumn3({label:objectTilesLabels.jobApplicants.label, value:totalApplications});
                }
            }

            if(rawTileData.totalPostings > 0) {
                if (tileFactory.isPrincipal()){
                    tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('totalPostings', 'totalPostingsURI'));
                }else {
                    tileFactory.addFieldToColumn4(tileFactory.field.newField('totalPostings'));
                }
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('closingSoon'));
            }


            // Adding status to tile data
            var STATUS_CLOSED, STATUS_OPENED, primaryStatusKey;
            if( tileFactory.isPrincipal() ){
                primaryStatusKey = 'itemStatus';
                STATUS_CLOSED = tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED;
                STATUS_OPENED = tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN;
            } else {
                primaryStatusKey = 'distributionStatus';
                STATUS_CLOSED = tileFactory.LOOKUP_VALUE.DISTRIBUTION_STATUS_CLOSED;
                STATUS_OPENED = tileFactory.LOOKUP_VALUE.DISTRIBUTION_STATUS_AWAITING_CLAIM;
            }

            tileFactory.addStatus(tileFactory.status.newCombinedStatus(primaryStatusKey, 'itemSecondaryStatus',
                // Positives
                [
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_FILLED
                    ],
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_COMPLETED
                    ]
                ],
                // Negatives
                [
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_IN_PROGRESS
                    ],
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_REJECTED
                    ],
                    [
                        STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_CANCELLED
                    ]
                ],
                // Warning
                [
                    [
                        STATUS_OPENED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        STATUS_OPENED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_IN_PROGRESS
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_IN_PROGRESS
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_BOOKING_AWAITING_START
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_BOOKING_AWAITING_START
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_SUBMISSIONS
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_SUBMISSIONS
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_POSTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_POSTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_INTERVIEWING
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_INTERVIEWING
                    ]
                ],
                [
                    [
                        STATUS_OPENED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DRAFT
                    ]
                ]
            ));
            if((rawTileData.alwaysRecruiting && rawTileData.isShiftItem) || (!rawTileData.alwaysRecruiting && rawTileData.isShiftItem)){
                tileFactory.addStatus(tileFactory.status.newStatusWithLookup('itemType', 'isShiftItem'));
            }else if(rawTileData.alwaysRecruiting && !rawTileData.isShiftItem){
                tileFactory.addStatus(tileFactory.status.newStatusWithLookup('itemType', 'alwaysRecruiting'));
            }else if(rawTileData.fixedTermContract) {
                tileFactory.addStatus(tileFactory.status.newStatusWithLookup('itemType', 'fixedTermContract'));
            } else if(rawTileData.retainer) {
                tileFactory.addStatus(tileFactory.status.newStatusWithLookup('itemType', 'retainer'));
            } else{
                tileFactory.addStatus(tileFactory.status.newStatus('itemType'));
            }

            if(rawTileData.itemIsPrincipal && rawTileData.itemFrameworkNameHoverText) {
                tileFactory.addStatus(tileFactory.status.newFrameworkStatus('itemFrameworkNameHoverText'));
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapDistributionTileService.$inject = ['tileDataFactory', '$filter'];
    angular.module('app').factory('mapDistributionTileService', mapDistributionTileService);
}());
